module.exports = __webpack_public_path__ + "img/Do-Contrast_ratio.f70d377a.png";